@if (showBanner) {
<div class="cookie-banner">
  <div class="info">
    Utilizamos exclusivamente cookies estritamente necessários para garantir o funcionamento do website. Para mais informações, consulte nossa <a (click)="abrirTermos()">Política de Privacidade</a>. Ao continuar navegando, você concorda com essa utilização.
  </div>
  <div class="actions">
    <button (click)="aceitarCookies()">OK</button>
  </div>
</div>
}
